import {Language} from "@variocube/app-api";
import {DateTime} from "luxon";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {stylesheet} from "typestyle";
import {AwesomeBarItem} from "./AwesomeBarItem";

interface ClockProps {
    language: string;
}

export function Clock({language}: ClockProps) {
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    const updateClock = useCallback(() => {
        const now = DateTime.local()
            .setLocale((language === Language.EN) ? "en-US" : language);
        setDate(now.toLocaleString(DateTime.DATE_SHORT));
        setTime(now.toLocaleString(DateTime.TIME_SIMPLE));
    }, [language]);

    useEffect(() => {
        const interval = window.setInterval(updateClock, 1000);
        return () => window.clearInterval(interval);
    }, [updateClock]);

    return (
        <AwesomeBarItem>
            <div className={styles.clock}>
                <div>{time}</div>
                <div>{date}</div>
            </div>
        </AwesomeBarItem>
    );
}

const styles = stylesheet({
    clock: {
        textAlign: "center",
        fontSize: "0.75em",
    }
});
